/* eslint-disable react/prop-types,jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'

import './ImageUploader.scss'

class ImageUploader extends Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  render(){
    const { t } = this.props
    return (
      <div className='image-uploader-container'>
        <p className='image-uploader-text'>{this.props.label}</p>
        <p className='image-uploader-recommendation'>{t('common.imageUploader.recommendation')}</p>
        <input
          type='file'
          id='input-photo-upload'
          name='file'
          onChange={this.props.onChange}
          accept={this.props.accept}
          className='image-uploader-input'
          multiple />
        <label htmlFor='file' className='image-uploader-label' onClick={this.props.selectImages}>
          <i className='fa fa-upload image-uploader-icon' aria-hidden='true'></i>
          {this.props.images.length > 0 ?
            t('common.imageUploader.imagesSelected', { count: this.props.images.length }) : t('common.imageUploader.chooseImages')}
        </label>
        {this.props.images.length > 0
          ? <button className='image-uploader-reset' onClick={this.props.reset}>{t('common.imageUploader.clearImages')}</button>
          : null}
        { this.props.images.length > 5 ? <p className='image-uploader-error'>{t('common.imageUploader.tooManyImages')}</p> : null }
      </div>
    )
  }
}

export default withTranslation()(ImageUploader)
